import {Injectable} from '@angular/core';
import {CountResponse, DataOBJ, DataObjService, RestService, Select2Data} from './rest-service';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {isNullOrUndefined} from 'util';

@Injectable()
export class DepartmentService implements DataObjService<Department> {

  restHelper: RestService<Department>;

  readonly apiPath = '/api/call_event/v1/department';

  static postProcess(departments: Department[]): Department[] {
    departments.forEach((department) => {
      department.parentName = DepartmentService.getParentName(department.parentId, departments);
    });
    return departments;
  }

  static getParentName(id: string, departments: Department[]): string {
    if (isNullOrUndefined(id) || id === '') {
      return null;
    } else {
      const parent = departments.find((department) => department.id === id);
      if (isNullOrUndefined(parent)) {
        console.error(`Department Parent not found: ${id}`);
        return null;
      } else {
        const parentName = this.getParentName(parent.parentId, departments);
        let parentPrefix = '';
        if (!isNullOrUndefined(parentName)) {
          parentPrefix = parentName + ' > ';
        }
        return parentPrefix + parent.description;
      }
    }
  }

  static getDepartmentsSelectData(departments: Department[], idToRemove: string = null ): Select2Data[] {
    return departments
      .filter((department) => department.id !== idToRemove)
      .map((department) => {
        let fullDescription = '';
        if (isNullOrUndefined(department.parentName)) {
          fullDescription = department.description;
        } else {
          fullDescription = department.parentName + ' > ' + department.description;
        }
        return {id: department.id, text: fullDescription}
      })
  }

  constructor(private httpClient: HttpClient) {
    this.restHelper = new RestService<Department>(this.apiPath, httpClient, Department.fromJSON)
  }

  countByCustomerIdAndDescriptionAndParentId(customerId: string, description: string, parentId: string): Observable<number> {
    let lookedParentId = '00000000-0000-0000-0000-000000000000';
    if (!isNullOrUndefined(parentId)) {
      lookedParentId = parentId;
    }
    return this.httpClient.get<CountResponse>(this.apiPath +
      `/count/customer/${customerId}/description/${encodeURI(description)}/parent_id/${lookedParentId}`)
      .map((res: CountResponse) => res.count);
  }

  getAll(): Observable<Department[]> {
    return this.restHelper.getAll();
  }

  getAllByCustomerId(customerId: string): Observable<Department[]> {
    return this.restHelper.getAllByCustomerId(customerId)
      .map((departments) => DepartmentService.postProcess(departments))
  }

  getById(id: string): Observable<Department> {
    return this.restHelper.getById(id);
  }

  save(obj: Department): Observable<Department> {
    return this.restHelper.save(obj);
  }

  update(obj: Department): Observable<Department> {
    return this.restHelper.update(obj);
  }

  delete(obj: Department): Observable<string> {
    return this.restHelper.delete(obj);
  }
}

export class Department implements DataOBJ {

  static fromJSON(json: any): Department {
    const object: Department = Object.create(Department.prototype);
    Object.assign(object, json);
    return object;
  }

  constructor(public id: string, public description: string, public parentId: string, public customerId: string,
              public deleted: boolean, public parentName: string) {
  }

  getHumanIdentifier() {
    return this.description;
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/department.service.ts